import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocale } from '../../i18n/context'
import { useTextFlowStore } from '../../stores/textFlowStore'

/**
 * Where leaving the flow goes: the screen that opened it. `exit` clears the
 * flow's state first, so a later entry starts clean; `backLabel` names the
 * origin for the desktop bar's back link (handoff §19.2).
 */
export function useFlowOrigin() {
  const navigate = useNavigate()
  const { tr } = useLocale()
  const origin = useTextFlowStore((s) => s.origin)
  const originLabel = useTextFlowStore((s) => s.originLabel)

  const exit = useCallback(() => {
    const to = useTextFlowStore.getState().origin
    useTextFlowStore.getState().reset()
    navigate(to)
  }, [navigate])

  const backLabel = originLabel ?? (origin.startsWith('/home') ? tr.nav.home : tr.nav.library)
  return { exit, backLabel, origin }
}
